/** Shopify CDN: Minification failed

Line 206:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 207:4 Transforming let to the configured target environment ("es5") is not supported yet

**/
var gUniqueID = "id" + Math.random().toString(16).slice(2);
var WebsiteDomain = window.location.protocol + '//' + location.host;

$(document).ready(function(){


   $('.product-form').append('<div style="position:relative;width:100%;display:flex;"><button class="buy_now_btn btn py-2 fs-6" data-bs-toggle="modal" data-bs-target="#exampleModal" >Buy Now</button><div class="rela_div"></div></div>');
   $('.product-price').text(separater($('#ProductPrice-product-template').attr('content')) + '.00');
   $('#oz_city').select2({width: '100%'});

   if($('.swatch .swatch-element input[name="option-0"]').length > 0 ){
     
     $('.rela_div').addClass('w-100');
     $('.rela_div').on('click' , function () {
         alert('plz select the attribute');
     });
     $('.buy_now_btn').prop('disabled', true);
     
     $(document.body).on('click' , '.swatch .swatch-element input[name="option-0"]' , function () {
       if($('.swatch .swatch-element input[name="option-0"]:checked').length > 0){
          $('.rela_div').removeClass('w-100');
          $('.buy_now_btn').prop('disabled', false); 
          $('.alert-msg').hide();
          $('.sticky_add_cart .product-price').text(separater($('.swatch .swatch-element input[name="option-0"]:checked').attr('price')) + '.00');
       }
     });
     
   }
  
  var product_image = $('.product-single__photo-wrapper .product-single__photo .product-featured-img').attr('src');
  $('#form_product_img, .sticky_add_cart_img').attr('src', product_image);
 
  var product_title = $('.product-single__title').text();
  $('#form_prduct_text, .product-title').text(product_title);

  // ON CLICK FUNCTION
  $('.buy_now_btn').on('click' , function (e) {
    e.preventDefault();
    
    $('#DiscountPrice').text('PKR. 00.00');
    
    if($('.swatch .swatch-element input[name="option-0"]').length > 0 ){
      var product_price = $('.swatch .swatch-element input[name="option-0"]:checked').attr('price');
      $('#variantion').text('Variant: ' + $('.swatch .swatch-element input[name="option-0"]:checked').attr('value'));
    }else{
       var product_price = $('#oz_price').val();
    }
    
    $('#form_product_price').text('PKR. ' + separater(product_price) + '.00');
    
    var product_quantity = $('#Quantity').val();
    $('#product_quantity').text(product_quantity);

    var subtotal_price = parseInt(product_quantity) * parseInt(product_price) + '.00';
    $('#subtotal_price').text('PKR. ' +  separater(subtotal_price) + '.00').attr('SubTotal',parseInt(product_quantity) * parseInt(product_price));

    var total = separater(subtotal_price) + '.00';
    $('#total_price').text('PKR. ' + total);

    $('.discount-input, .discount-btn').prop('disabled', false);
    $('.discount-input').val('');

    
  }); 

  // DISCOUNT CODE FUNCTION
  $(document.body).on('click','.discount-btn',function(){
  
    $('.spinner-bg').removeClass('HideClass');
    
    $.ajax({
      url:'https://shopifybuynow.ozbix.com/DiscountCheck.php',
      crossDomain: true,
      dataType : 'json',
      method:'POST',
      data: {
        domain: WebsiteDomain,
        UniqueID:gUniqueID,
        DiscountCode:$('.discount-input').val()
      },
      success:function (response) {
          if(response.status){
            
            var Result = JSON.parse(response.result);
            var DiscountType = Result.DiscountType;
            var DiscountAmount = Result.DiscountAmount;
            var DiscountPrice = 0;
            
            if(DiscountType == "percentage"){
              
              var SubTotal = $('#subtotal_price').attr('Subtotal');
              DiscountPrice = (parseFloat(SubTotal)*parseFloat(DiscountAmount))/100;
              $('.discount-input, .discount-btn').prop('disabled', true);

              $('#DiscountPrice').text('PKR. '+ separater(DiscountPrice) + '.00').attr('DiscountPrice',DiscountPrice);
              $('#total_price').text('PKR. ' + separater(parseFloat(SubTotal) - DiscountPrice) + '.00');

              $('.spinner-bg').addClass('HideClass');
              
            }else if(DiscountType == "fixed_amount"){
              
              var SubTotal = $('#subtotal_price').attr('Subtotal');
              $('.discount-input, .discount-btn').prop('disabled', true);

              $('#DiscountPrice').text('PKR. '+ separater(DiscountAmount) + '.00').attr('DiscountPrice',DiscountAmount);
              $('#total_price').text('PKR. ' + separater(parseFloat(SubTotal) - DiscountAmount) + '.00');

              $('.spinner-bg').addClass('HideClass');
            }
            
            $('.spinner-bg').addClass('HideClass');
            
          }else{
            
            $('#coupon-error').text(response.message);
            $('.spinner-bg').addClass('HideClass');
            
          }
        
      },
      error: function(xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        alert(err.Message);
      }

    });
    

  });

  // BUYNOW FUNCTION
  $('#buy_now_form').on('submit' , function (e) {
    e.preventDefault();
    
    $('#city_error').hide();
    
    if($('#oz_name').val().length > 0 && $('#oz_number').val().length >= 11 && $('#oz_email').val().length > 0 && $('#oz_city').val() != '0' && $('#oz_address').val().length > 0 ){
        $('.form-spinner').removeClass('HideClass');
    
        var product_quantity = $('#Quantity').val();
        var variant_id = $('.product-form__variants[name="id"]').val();
        var name = $('#oz_name').val();
        var phoneNumber= $('#oz_number').val(); 
        var email = $('#oz_email').val();
        var city = $('#oz_city').val();
        var address = $('#oz_address').val();
        var notes = $('#oz_notes').val();
    
        $.ajax({
        url:'https://shopifybuynow.ozbix.com/create-ordernew.php',
        crossDomain: true,
        dataType : 'json',
        method:'POST',
        data: {
          domain: WebsiteDomain,
          variant_id: variant_id,
          name: name,
          email: email,
          city: city,
          phone: phoneNumber,
          quantity: product_quantity,
          address: address,
          UniqueID:gUniqueID,
          notes: notes
        },
        success:function (response) {
          console.log(response);
          if(response.status){
            localStorage.setItem('buynow', 'true');
            var Result = JSON.parse(response.result);
            window.location = Result.order.order_status_url;
            
          }
          
          $('.form-spinner').addClass('HideClass');
            // var data = JSON.parse(response);
            // window.location = data.order.order_status_url;
        },
        error: function(response) {
          console.log('error');
          console.log(response);
        }
    
      });
    }else{
      if($('#oz_number').val().length < 11){
        $('#oz_number').css({'border':'1px solid red','background':'none'}); 
        $('#oz_number').siblings('.invalid-feedback').text('Your Phone Number is less than 11').show();
      }

      if($('oz_city').val() === '0')
        $('#city_error').show();
    }
    
    
  });

  // FUNCTION COMMA SEPARATE
  function separater(price) {
    let parseprice = parseFloat(price);
    let formattedprice = parseprice.toLocaleString("en-US");
    return formattedprice;
  }
});